export class DoubleRangeSlider {
  static controlFromSlider(fromSlider, toSlider, fromInput, unit, toSliderMinValue) {
    const [from, to] = DoubleRangeSlider.getParsed(fromSlider, toSlider);
    DoubleRangeSlider.fillSlider(fromSlider, toSlider, 'transparent', '#0E1746', toSlider);
    if (from > to) {
      fromSlider.val(to);
      fromInput.text(`${to}${unit}`);
    } else {
      fromInput.text(`${from}${unit}`);
    }
    // 最小値を下回った場合は「下限なし」と表示
    if (from <= toSliderMinValue) {
      fromInput.text('下限なし');
    }
  }

  static controlToSlider(fromSlider, toSlider, toInput, unit, toSliderMaxValue) {
    const [from, to] = DoubleRangeSlider.getParsed(fromSlider, toSlider);
    DoubleRangeSlider.fillSlider(fromSlider, toSlider, 'transparent', '#0E1746', toSlider);
    if (from <= to) {
      toSlider.val(to);
      toInput.text(`${to}${unit}`);
    } else {
      toInput.text(`${from}${unit}`);
      toSlider.val(from);
    }
    // 最大値を超えた場合は「上限なし」と表示
    if (to >= toSliderMaxValue) {
      toInput.text('上限なし');
    }
  }

  static clickSlider(clickPosition, sliderWidth, fromSlider, toSlider) {
    const [from, to] = DoubleRangeSlider.getParsed(fromSlider, toSlider);
    const minX = fromSlider.attr('min');
    const maxX = fromSlider.attr('max');

    // スライダーの値をピクセル単位で計算
    const valuePerPixel = (maxX - minX) / sliderWidth;
    const clickValue = minX + clickPosition * valuePerPixel;

    // クリック位置に最も近いつまみを判断
    const diffFrom = Math.abs(from - clickValue);
    const diffTo = Math.abs(to - clickValue);

    if (diffFrom < diffTo) {
      fromSlider.val(clickValue);
      fromSlider.trigger('input');
    } else {
      toSlider.val(clickValue);
      toSlider.trigger('input');
    }
  }

  static resetFromSlider(fromSlider, toSlider, fromInput, initialFromValue) {
    fromSlider.val(initialFromValue);
    fromInput.text('下限なし');
    DoubleRangeSlider.fillSlider(fromSlider, toSlider, 'transparent', '#0E1746', toSlider);
  }

  static resetToSlider(fromSlider, toSlider, toInput, initialToValue) {
    toSlider.val(initialToValue);
    toInput.text('上限なし');
    DoubleRangeSlider.fillSlider(fromSlider, toSlider, 'transparent', '#0E1746', toSlider);
  }

  static resetSlider(fromSlider, toSlider, fromInput, toInput, initialFromValue, initialToValue) {
    DoubleRangeSlider.resetFromSlider(fromSlider, toSlider, fromInput, initialFromValue);
    DoubleRangeSlider.resetToSlider(fromSlider, toSlider, toInput, initialToValue);
  }

  static getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.val(), 10);
    const to = parseInt(currentTo.val(), 10);
    return [from, to];
  }

  static fillSlider(fromSlider, toSlider, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = toSlider.attr('max') - toSlider.attr('min');
    const fromPosition = fromSlider.val() - toSlider.attr('min');
    const toPosition = toSlider.val() - toSlider.attr('min');
    const style = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} 100%)`;
    controlSlider.css('background', style);
  }
}
